import { render, staticRenderFns } from "./emotionAnalysis.vue?vue&type=template&id=15d82e2f&scoped=true&"
import script from "./emotionAnalysis.vue?vue&type=script&lang=js&"
export * from "./emotionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./emotionAnalysis.vue?vue&type=style&index=0&id=15d82e2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d82e2f",
  null
  
)

export default component.exports